import React, { FC } from 'react';
import styles from './icons.module.scss';

const IconUp: FC = () => <img src="/images/icon_chevron.svg" alt="close filter section" className={styles.icon} />;

export default IconUp;
